export default "__VITE_ASSET__6uBb2f0L__"